import React, { useContext } from "react";
import IPrice_Band_Compiled from "../../../models/IPrice_Band_Compiled";
import HelperService from "../../../services/HelperService";
import SupplierContext from "../../../contexts/SupplierContext";
import ICurrency from "../../../models/ICurrency";

type Props = {
    bands: IPrice_Band_Compiled[];
    currency?: ICurrency;
};

export const PriceBandPriceDisplay = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    return (
        <div className={"PriceBandPriceDisplay"}>
            {(props.bands || []).map((priceBand) => {
                const hasEndQty = !!priceBand.end_qty;
                return (
                    <div key={priceBand.guid} className={"d-flex no-wrap"}>
                        {HelperService.formatCurrency({
                            value: priceBand.price,
                            currency: props.currency?.name || "USD",
                            precision: supplierModel.pricing_precision,
                        })}
                        <div className={"d-flex ms-2"}>
                            (<div className={hasEndQty ? "me-1" : ""}>{priceBand.start_qty}</div>
                            <div>{hasEndQty ? `- ${priceBand.end_qty}` : "+"}</div>)
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
